window.GoodFaithEstimateAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("GoodFaithEstimatesServers"));


    self.getGFEIntervals = function (brandId, startDate, statuses) {
        var deferred = $q.defer();

        var payload = {
            start_date : moment(startDate).format("YYYY-MM-DD")
        };

        if (statuses && statuses.length) {
            payload.statuses = statuses.join(',');
        }


        _protected.request('brands/' + brandId + '/users/good_faith_estimates', 'GET', payload)
            .then(function (result) {
            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUsersWithPendingGFE = function (brandId) {
        var deferred = $q.defer();

        _protected.request('regular_schedule/brands/' + brandId + '/users/good_faith_estimates/pending', 'GET').then(function (result) {
            if (result && result.data && result.data.data && result.status === 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getScheduleBaseLineHours = function (brandId, userId, effectiveDate) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        let params = {};
        if (effectiveDate) {
            params['effective_date'] = effectiveDate;
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/regular_scheduling/info', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getTemplateSettings = function (brandId, isPermShift) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        let params = {
            include_permanent_shift_pickups: !!isPermShift
        };

        _protected.request('brands/' + brandId + '/templates/settings', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data.settings || {});
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    const [getRegularScheduleSettings] = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/regular_scheduling/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    });

    self.getRegularScheduleSettings = getRegularScheduleSettings;

    self.getRegularScheduleVariations = function (financialUnitID, weekStartDate, brandId, mode) {
        var defer = $q.defer();

        if (!financialUnitID) {
            throw "No brand id";
        }

        var payload = {
            week_start_date: weekStartDate
        }

        if (mode) {
            payload.mode = mode;
        }

        if (brandId) {
            payload.locations_ids = brandId;
        }

        _protected.request('regular_schedule/brands/' + financialUnitID + '/variations', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    }

    self.getGFEAttachmentSignedUrl = function (brandId, payload) {
        var defer = $q.defer();
        if (!brandId) {
            throw "Brand id is required ";
        }

        _protected.request('brands/' + brandId + '/regular_scheduling/attachments/presigned_url', 'GET', payload)
            .then(function (res) {
                if (res.data && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.sendGFEDocument = function (brandId, data) {
        var defer = $q.defer();

            _protected.request('brands/' + brandId + '/documents', 'POST', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    const [getGFEBrandSettings] = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    });

    self.getGFEBrandSettings = getGFEBrandSettings;

    self.getGFETemplateSettings = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/templates/settings', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getRegularScheduleDocumentVariations = function (financialUnitId, GFEId) {
        var defer = $q.defer();

        if (!financialUnitId) {
            throw "No brand id";
        }

        _protected.request('regular_schedule/brands/'+ financialUnitId +'/good_faith_estimates/'+ GFEId +'/variations', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    }

    self.getAllowedEmployers = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/employers', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandGFESignificantChangeNotificationsSettings = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/significant_change/notifications', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.updateBrandGFESignificantChangeNotificationsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/significant_change/notifications', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandGFEExpirationChangeNotificationsSettings = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/gfe_expiration/notifications', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.updateBrandGFEExpirationNotificationsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/gfe_expiration/notifications', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserGoodFaithEstimates = function (brandId, userId, payLoad) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/good_faith_estimates', 'GET', payLoad)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status === 200) {
                    defer.resolve(result.data.data);
                } else {
                    defer.reject(result);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.getUserGFEDetailsById = function (brandId, userId, GFEId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/good_faith_estimates/' + GFEId, 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status === 200) {
                    defer.resolve(result.data.data);
                } else {
                    defer.reject(result);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };


    self.getUserGFEIncidents = function (brandId, userId, GFEId, weekRangeDate) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var payload = {};
        if (weekRangeDate && weekRangeDate.start_date && weekRangeDate.end_date) {
            payload = weekRangeDate;
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/good_faith_estimates/' + GFEId + '/incidents', 'GET', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status === 200) {
                    defer.resolve(result.data.data);
                } else {
                    defer.reject(result);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getUserEffectedGoodFaithEstimates = async (userId, brandId, shiftStartTime) => {

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        let params = {
            from_date: shiftStartTime
        };

        let response = await _protected.request(`brands/${brandId}/users/${userId}/good_faith_estimates/effective`, 'GET', params);
        if (response.status === 200) {
            return response.data.data?.good_faith_estimates;
        } else {
            throw response;
        }
    };

    self.getLastGoodFaithEstimateDoc = async (brandId, userId, startDate) => {
        let params = {
            start_date: startDate,
        };
        let response = await _protected.request(`brands/${brandId}/users/${userId}/good_faith_estimates/last_document`, 'GET', params);
        if (response.status === 200) {
            return response.data.data;
        } else {
            throw response;
        }
    };
};